export default "__VITE_ASSET__DO4S$J$7__"